import { getBidWaybillActionFlags } from "helpers/bidWaybillActions";
import { bidStateFlags, bidStateFlagsEnum } from "helpers/enums/bidStateFlags";
import { enumLabel } from "helpers/system";
import React from "react";

const compactLabels: Record<string, string> = {
    [bidStateFlagsEnum.WaybillTitleSignRequired]: "ЭТрН",
    [bidStateFlagsEnum.WaybillChangeTitleRequired]: "Т8",
    [bidStateFlagsEnum.WaybillExternalRevisionsSignRequired]: "Испр.",
    [bidStateFlagsEnum.WaybillDeliveryCompletionRequired]: "Контур",
};

/** Display all bid-level action reasons without choosing a document's external link. */
export const BidWaybillActionBadges = ({
    intStateFlags,
    compact = false,
}: {
    intStateFlags: number;
    compact?: boolean;
}) => (
    <>
        {getBidWaybillActionFlags(intStateFlags).map((flag) => (
            <span
                key={flag}
                className="badge badge-warning text-wrap mr-1 mb-1"
                title={compact ? enumLabel(bidStateFlags, flag) : undefined}
                aria-label={compact ? enumLabel(bidStateFlags, flag) : undefined}
            >
                {compact ? compactLabels[flag] : enumLabel(bidStateFlags, flag)}
            </span>
        ))}
    </>
);
